
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

export default {
directives: {
TransferDom
},
components: {
Flexbox,
FlexboxItem,
Scroller,
LoadMore,
Confirm,
XDialog,
Toast
},
data() {
return {
NoteList: [],
column: "RelatedID1",
onFetching: false,
bottomCount: 1,
keyID: "",
show:false,
title:"",
content:"",
showPositionValue:false,
texts:""
}
},
created() {
if (this.$route.params.ID != "" && this.$route.params.ID != undefined) {
this.column = "RelatedID2";
this.keyID = this.$route.params.ID;
} else {
this.keyID = this.$route.params.IDCode;
this.column = "RelatedID1";
}
this.NotesList();
},
mounted() {
if(!this.GLOBAL.isLogin){
var hrefUrl = location.host;
hrefUrl = "http://softtone.jqweike.com/login?callback=" + encodeURIComponent(hrefUrl);
document.getElementById("a").href = hrefUrl;
}else{
document.getElementById("content").style.height = window.innerHeight * 0.15 +"px";
document.getElementById("titles").style.height = window.innerHeight * 0.03 +"px";
}
},
methods: {
NotesList:function(){
this.$tyh.getNoteList(this.keyID, this.column, "1")
.then((data) => {
this.NoteList = data.data.Data.rows;
});
},
DelNote: function (noteID) {
const _this = this
this.$vux.confirm.show({
title: '是否删除该笔记？',
content: '',
onConfirm() {
_this.$tyh.DeleteNote(noteID)
.then((data) => {
if (data.data.Status == 0) {
_this.NotesList();
}
});
}
})
},
onScrollBottom() {
if (this.onFetching) {

} else {
this.onFetching = true
setTimeout(() => {
this.bottomCount += 1;
this.$tyh.getNoteList(this.$route.params.IDCode, this.column, this.bottomCount)
.then((data) => {
if (data.data.Data.rows != 0) {
this.NoteList = this.NoteList.concat(data.data.Data.rows);
if (data.data.Data.rows.length < 10) {
document.getElementById("loadMore").style.display = "none";
}
} else {
var load = document.getElementById("loadMore");
if (load.style != "none")
load.style.display = "none"
}
});
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
this.onFetching = false
}, 100)
}
},

dateFormat: function (time) {
var date = new Date(time);
var year = date.getFullYear();
/* 在日期格式中，月份是从0开始的，因此要加0
* 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05 */
var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
},

AddNote:function(){
var title = this.title;
var content = this.content;
if(title=="" || title == undefined){
this.showPositionValue=true;
this.texts = "请输入标题"
}else{
this.title = "";
this.content = "";
var CourseID = this.GLOBAL.IDCode;
var VideoID =  this.GLOBAL.ChapterID;

this.$tyh.GetByChapterID(VideoID)
.then((data) => {
if(data.data.Status !=0 ){
return ;
}
VideoID = data.data.Data.resource.ID;
this.$tyh.AddNote(title,content,CourseID,VideoID)
.then((data) => {
this.NotesList();
this.show = false;
})

})



}
},
close:function(){
this.title = "";
this.content = "";
this.show = false
}
}
}



// WEBPACK FOOTER //
// ./src/views/Index/Course/Note.vue